/**
 * Module dependencies.
 */

import { Modal } from 'antd';
import { Button } from 'app/components/atoms/button/button';
import { Form } from 'app/components/organisms/crud/crud-form';
import { FormCheckBoxField } from 'app/components/organisms/crud/form-components/form-checkbox-field';
import { FormInputField } from 'app/components/organisms/crud/form-components/form-input-field';
import { requiredRule } from 'app/core/utils/field-rules';
import { usePosUserCustomNotification } from 'app/hooks/app-requests/user/use-post-notification';
import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

/**
 * Export `SendNotificationButton` component.
 */

export function SendNotificationButton(): JSX.Element {
  const [translate] = useTranslation();
  const [isOpen, setOpen] = useState(false);
  const params = useParams();
  const { mutateAsync: sendNotification } = usePosUserCustomNotification();
  const handleSubmit = useCallback(
    async (data: any) => {
      await sendNotification({
        userId: params.userId,
        ...data
      });
    },
    [params.userId, sendNotification]
  );

  const form1 = useForm<any>({
    values: {},
    mode: 'all'
  });

  useEffect(() => {
    if (isOpen) {
      return;
    }

    form1.reset();
  }, [form1, isOpen]);

  return (
    <>
      <Button onClick={() => setOpen(true)} type={'primary'}>
        {translate('users.userInfo.debugger.sendNotificationButton')}
      </Button>

      <Modal
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { display: 'none' } }}
        onCancel={() => {
          setOpen(false);
        }}
        open={isOpen}
        title={translate('users.userInfo.debugger.modals.notification.title')}
        width={'40%'}
      >
        <Form form={form1} onSubmit={handleSubmit} submitLabel={'NEXT'}>
          <>
            <FormInputField
              form={form1}
              item={{
                label: translate('users.userInfo.debugger.modals.notification.formTitle'),
                rules: requiredRule(translate),
                name: 'title',
                type: 'inputField'
              }}
            />

            <FormInputField
              form={form1}
              item={{
                label: translate('users.userInfo.debugger.modals.notification.message'),
                rules: requiredRule(translate),
                name: 'body',
                type: 'inputField',
                inputType: 'textArea'
              }}
            />

            <FormCheckBoxField
              form={form1}
              item={{
                label: translate('users.userInfo.debugger.modals.notification.sound'),
                name: 'sound',
                type: 'inputField',
                rules: undefined
              }}
              name={'sound'}
            />
          </>
        </Form>
      </Modal>
    </>
  );
}
